module.exports = __webpack_public_path__ + "img/lit_disclaimer.bb4208fe.png";